import Vue from "vue";
import Router from "vue-router";

import Cars from "./views/Cars";
import Item from "./views/Item";
import PasswordSet from "./views/user/PasswordSet";
import PasswordReset from "./views/user/PasswordReset";
import Control from "./views/Control";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Cars",
      component: Cars,
    },
    {
      path: "/partida/:auction/:item",
      name: "Item",
      component: Item,
    },
    {
      path: "/usuario/crear/:passwordCode",
      name: "PasswordSet",
      component: PasswordSet,
    },
    {
      path: "/usuario/restablecer",
      name: "PasswordReset",
      component: PasswordReset,
    },
    {
      path: "/control",
      name: "Control",
      component: Control,
    },
    {
      path: "*",
      redirect: "/",
    },
  ],
});
